// // // import React from "react";
// // // import avsyncImg from "../imgs/avsync.jpg";
// // // import "../App.css";
// // // import { Helmet } from "react-helmet"; // for SEO meta-tags! Yes!!!
// // // export default function AvSyncPage() {
// // //   return (
// // //     // SEO injection ----- Metag tahgs----
// // //     <>
// // //       <Helmet>
// // //         <title>AV Sync — Device Management App</title>
// // //         <meta
// // //           name="description"
// // //           content="AV Sync is a cross-platform device management tool built by Savannah Chanel Victoria, featuring network scanning, maintenance tracking, and real-time device reports."
// // //         />
// // //         <meta
// // //           name="keywords"
// // //           content="AV Sync, AV scanner, network device scanner, production app, AV engineering, device inventory, tech director tools, house of worship, church production, live production tools, AV network"
// // //         />
// // //         <meta property="og:title" content="AV Sync — Beta Launch" />
// // //         <meta
// // //           property="og:description"
// // //           content="Cross-platform AV device manager with scanning, inventory, alerts, and PDF reporting — built by Savannah Chanel Victoria."
// // //         />
// // //         <meta property="og:type" content="website" />
// // //         <meta
// // //           property="og:image"
// // //           content="https://savannahchanel.me/assets/avsync-thumbnail.jpg"
// // //         />
// // //         <meta property="og:url" content="https://savannahchanel.me/avsync" />
// // //       </Helmet>

// // //       <div className="posts">
// // //         {/* PAGE TITLE */}
// // //         <h1>AV Sync</h1>
// // //         <p className="intro-text">
// // //           A cross-platform device management tool built for production and
// // //           technical teams — designed to scan and help track AV equipment.
// // //         </p>

// // //         {/* --- FEATURE CARD --- */}
// // //         <div className="post-item">
// // //           <img src={avsyncImg} alt="AV Sync screenshot" className="post-img" />

// // //           <div className="post-content">
// // //             <h2 className="post-title">Core Features</h2>

// // //             <ul className="post-pargrphs">
// // //               <li>Real-time device scanning</li>
// // //               <li>MongoDB storage + Render API backend</li>
// // //               <li>Secure Firebase Authentication</li>
// // //               <li>CRUD operations with Axios</li>
// // //               <li>Maintenance scheduling with custom alerts</li>
// // //               <li>PDF exports (device reports + IT tickets)</li>
// // //             </ul>

// // //             <div className="project-links">
// // //               <a
// // //                 className="post-links"
// // //                 href="https://2506-wdv-349-victoria-savannah.vercel.app"
// // //                 target="_blank"
// // //                 rel="noopener noreferrer"
// // //               >
// // //                 Live Site
// // //               </a>

// // //               <a className="post-links" href="#launch">
// // //                 Press Release
// // //               </a>

// // //               <a className="post-links" href="#beta">
// // //                 Beta Notes
// // //               </a>
// // //               {/* Scanenr file downlaod ---- */}
// // //               <a
// // //                 href="/assets/AVSync-LocalScanner-Release.zip"
// // //                 download
// // //                 class="download-btn"
// // //               >
// // //                 Download Local Scanner Utility
// // //               </a>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* --- PRESS RELEASE CARD --- */}
// // //         <div id="launch" className="post-item">
// // //           <h2 className="post-title">📣 Official Launch Announcement</h2>
// // //           <p className="post-pargrphs">
// // //             <strong>Press Release — November 16, 2025</strong>
// // //           </p>

// // //           <p className="post-pargrphs">
// // //             AV Sync Beta v1.0 is officially live. This marks the first public
// // //             beta release of a platform built to help production and technical
// // //             teams scan, track, and maintain AV devices — all from one unified
// // //             interface.
// // //           </p>

// // //           <p className="post-pargrphs">
// // //             Built as part of my capstone project at Full Sail University, this
// // //             beta represents a major milestone in my development journey —
// // //             combining full-stack development, network scanning workflows,
// // //             authentication strategies, and UI/UX design into a functional,
// // //             real-world application.
// // //           </p>
// // //           <p className="post-pargrphs">
// // //             Your feedback means a lot as AV Sync continues to grow. This beta
// // //             launch marks the official release of my capstone project, and I’ll
// // //             be refining and expanding features as I move toward a full
// // //             production version.
// // //           </p>
// // //         </div>
// // //         <div className="post-item">
// // //           <h2 className="post-title">⚠️ Transparency Notes</h2>

// // //           {/* <p className="post-pargrphs">
// // //             The current beta launch version uses{" "}
// // //             <strong>mock device data</strong> unless you download and run the
// // //             optional <strong>AV Sync Local Network Scanner Utility</strong>.
// // //             This standalone Node.js tool already supports real device discovery
// // //             on your local network.
// // //           </p> */}
// // //           <p className="post-pargrphs">
// // //             The current beta launch version uses{" "}
// // //             <strong>mock device data</strong> due to modern network security
// // //             limitations — and the fact that web browsers cannot directly scan a
// // //             user’s local network — real-time device discovery isn’t technically
// // //             feasible inside a standard web app.
// // //           </p>
// // //           <p className="post-pargrphs">
// // //             Because of this, AV Sync Beta v1.0 uses mock device data for testing
// // //             and demonstration purposes, while a secure standalone Local Scanner
// // //             Utility is being developed to enable real network scanning on a
// // //             user’s own machine.
// // //           </p>
// // //           <p className="post-pargrphs">
// // //             I’m actively working on connecting this utility directly to the AV
// // //             Sync frontend so the real-time scanning workflow can run seamlessly
// // //             inside the web app. Once this final integration step is complete,
// // //             users will be able to scan, sync, and store devices instantly
// // //             without using mock data.
// // //           </p>

// // //           <p className="post-pargrphs">
// // //             The Local Scanner Utility will be publicly released soon as part of
// // //             the next beta update, along with setup instructions for macOS.
// // //           </p>

// // //           <p className="post-pargrphs">
// // //             I’m also planning a dedicated macOS desktop version of AV Sync using
// // //             Electron.js for production teams who prefer running all tools
// // //             locally. This will be a future release as well.
// // //           </p>
// // //         </div>

// // //         {/* --- ACCESS INFO CARD --- */}
// // //         <div className="post-item">
// // //           <h2 className="post-title">🔐 Access Information</h2>

// // //           <p>
// // //             <strong>You have two options:</strong>
// // //           </p>

// // //           <ol className="post-pargrphs">
// // //             <li>
// // //               <strong>Create your own account (preferred):</strong>
// // //               <ul>
// // //                 <li>Use your personal email</li>
// // //                 <li>Click “Register New Account” on the login page</li>
// // //               </ul>
// // //             </li>

// // //             <li>
// // //               <strong>Use the mock test user:</strong>
// // //               <ul>
// // //                 <li>
// // //                   Email: <code>test@email.com</code>
// // //                 </li>
// // //                 <li>
// // //                   Password: <code>Test1234!</code>
// // //                 </li>
// // //               </ul>
// // //             </li>
// // //           </ol>
// // //         </div>

// // //         {/* --- WHAT TO TEST CARD --- */}
// // //         <div className="post-item">
// // //           <h2 className="post-title">✅ What to Test</h2>

// // //           <ul className="post-pargrphs">
// // //             <li>Login & registration (Firebase Auth)</li>
// // //             <li>Add, edit, and delete devices — confirm real-time updates</li>
// // //             <li>
// // //               Custom maintenance scheduling tag (alert will appear on Web)
// // //             </li>
// // //             <li>Generate IT ticket + device summary PDF reports</li>
// // //             <li>General UX feedback (layout, spacing, navigation clarity)</li>
// // //           </ul>
// // //         </div>

// // //         {/* --- BETA NOTES CARD --- */}
// // //         <div id="beta" className="post-item">
// // //           <h2 className="post-title">📝 Beta Release Notes</h2>

// // //           <ul className="post-pargrphs">
// // //             <li>
// // //               This version uses <strong>mock device data</strong> for testing
// // //             </li>
// // //             <li>Export filters + side menus still in development</li>
// // //             <li>Email verification + role management coming soon</li>
// // //             <li>
// // //               Some responsive layout shifts — refining for smaller screens
// // //             </li>
// // //           </ul>
// // //         </div>

// // //         {/* --- FEEDBACK CARD --- */}
// // //         <div className="post-item">
// // //           <h2 className="post-title">💬 Share Your Feedback</h2>
// // //           <p className="post-pargrphs">
// // //             If you find bugs, notice issues, or have ideas — I’d love to hear
// // //             from you!
// // //             <br />
// // //             <a
// // //               className="post-links"
// // //               href="mailto:scvictoria@wanderstudios.org"
// // //             >
// // //               scvictoria@wanderstudios.org
// // //             </a>
// // //           </p>
// // //         </div>
// // //       </div>
// // //     </>
// // //   );
// // // }
// // import React from "react";
// // import avsyncImg from "../imgs/avsync.jpg"; // replace with your real screenshot
// // import "../App.css";
// // import { Helmet } from "react-helmet"; // for SEO meta-tags! Yes!!!
// // export default function AvSyncPage() {
// //   return (
// //     <>
// //       <Helmet>
// //         <title>AV Sync — Device Management App</title>
// //         <meta
// //           name="description"
// //           content="AV Sync is a cross-platform device management tool built by Savannah Chanel Victoria, featuring network scanning, maintenance tracking, and real-time device reports."
// //         />
// //         <meta
// //           name="keywords"
// //           content="AV Sync, AV scanner, network device scanner, production app, AV engineering, device inventory, tech director tools, house of worship, church production, live production tools, AV network"
// //         />
// //         <meta property="og:title" content="AV Sync — Beta Launch" />
// //         <meta
// //           property="og:description"
// //           content="Cross-platform AV device manager with scanning, inventory, alerts, and PDF reporting — built by Savannah Chanel Victoria."
// //         />
// //         <meta property="og:type" content="website" />
// //         <meta
// //           property="og:image"
// //           content="https://savannahchanel.me/assets/avsync-thumbnail.jpg"
// //         />
// //         <meta property="og:url" content="https://savannahchanel.me/avsync" />
// //       </Helmet>

// //       <div className="posts">
// //         {/* PAGE TITLE */}
// //         <h1>AV Sync</h1>
// //         <p className="intro-text">
// //           A cross-platform device management tool built for production and
// //           technical teams — designed to scan and help track AV equipment.
// //         </p>

// //         {/* --- FEATURE CARD --- */}
// //         <div className="post-item">
// //           <img src={avsyncImg} alt="AV Sync screenshot" className="post-img" />

// //           <div className="post-content">
// //             <h2 className="post-title">Core Features</h2>

// //             <ul className="post-pargrphs">
// //               <li>Real-time device scanning</li>
// //               <li>MongoDB storage + Render API backend</li>
// //               <li>Secure Firebase Authentication</li>
// //               <li>CRUD operations with Axios</li>
// //               <li>Maintenance scheduling with custom alerts</li>
// //               <li>PDF exports (device reports + IT tickets)</li>
// //             </ul>

// //             <div className="project-links">
// //               <a
// //                 className="post-links"
// //                 href="https://2506-wdv-349-victoria-savannah.vercel.app"
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //               >
// //                 Live Site
// //               </a>

// //               <a className="post-links" href="#launch">
// //                 Press Release
// //               </a>

// //               <a className="post-links" href="#beta">
// //                 Beta Notes
// //               </a>

// //               {/* Scanner file download ---- */}
// //               <a
// //                 href="/assets/AVSync-LocalScanner-Release.zip"
// //                 download
// //                 className="download-btn"
// //               >
// //                 Download Local Scanner Utility
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         {/* --- PRESS RELEASE CARD --- */}
// //         <div id="launch" className="post-item">
// //           <h2 className="post-title">📣 Official Launch Announcement</h2>
// //           <p className="post-pargrphs">
// //             <strong>Press Release — November 16, 2025</strong>
// //           </p>

// //           <p className="post-pargrphs">
// //             AV Sync Beta v1.0 is officially live. This marks the first public
// //             beta release of a platform built to help production and technical
// //             teams scan, track, and maintain AV devices — all from one unified
// //             interface.
// //           </p>

// //           <p className="post-pargrphs">
// //             Built as part of my capstone project at Full Sail University, this
// //             beta represents a major milestone in my development journey —
// //             combining full-stack development, network scanning workflows,
// //             authentication strategies, and UI/UX design into a functional,
// //             real-world application.
// //           </p>
// //           <p className="post-pargrphs">
// //             Your feedback means a lot as AV Sync continues to grow. This beta
// //             launch marks the official release of my capstone project, and I’ll
// //             be refining and expanding features as I move toward a full
// //             production version.
// //           </p>
// //         </div>

// //         {/* --- TRANSPARENCY NOTES --- */}
// //         <div className="post-item">
// //           <h2 className="post-title">⚠️ Transparency Notes</h2>

// //           <p className="post-pargrphs">
// //             The current beta launch version uses{" "}
// //             <strong>mock device data</strong> due to modern network security
// //             limitations — and the fact that web browsers cannot directly scan a
// //             user’s local network — real-time device discovery isn’t technically
// //             feasible inside a standard web app.
// //           </p>
// //           <p className="post-pargrphs">
// //             Because of this, AV Sync Beta v1.0 uses mock device data for testing
// //             and demonstration purposes, while a secure standalone Local Scanner
// //             Utility is being developed to enable real network scanning on a
// //             user’s own machine.
// //           </p>
// //           <p className="post-pargrphs">
// //             I’m actively working on connecting this utility directly to the AV
// //             Sync frontend so the real-time scanning workflow can run seamlessly
// //             inside the web app. Once this final integration step is complete,
// //             users will be able to scan, sync, and store devices instantly
// //             without using mock data.
// //           </p>

// //           <p className="post-pargrphs">
// //             The Local Scanner Utility will be publicly released soon as part of
// //             the next beta update, along with setup instructions for macOS.
// //           </p>

// //           <p className="post-pargrphs">
// //             I’m also planning a dedicated macOS desktop version of AV Sync using
// //             Electron.js for production teams who prefer running all tools
// //             locally. This will be a future release as well.
// //           </p>
// //         </div>

// //         {/* --- CHANGE LOG! YESSS 🔥🔥🔥 --- */}
// //         <div className="post-item">
// //           <h2 className="post-title">🆕 Change Log</h2>

// //           <ul className="post-pargrphs">
// //             <li>
// //               <strong>Nov 22, 2025 — Local Scanner Utility Released 🎉</strong>
// //               <ul>
// //                 <li>
// //                   Added a downloadable{" "}
// //                   <strong>AV Sync Local Scanner Utility</strong> for macOS
// //                   users.
// //                 </li>
// //                 <li>
// //                   Users can now perform real local network scanning and sync
// //                   results directly to their own AV Sync account using their UID.
// //                 </li>
// //                 <li>
// //                   Devices now use improved fallback naming (e.g., Unnamed
// //                   Device: 8) with proper auto-increment based on DB values.
// //                 </li>
// //                 <li>Duplicate IPs are now automatically detected & skipped.</li>
// //                 <li>New “Download Local Scanner Utility” button added.</li>
// //               </ul>
// //             </li>

// //             <li>
// //               <strong>Nov 16, 2025 — Beta v1.0 Launch 🚀</strong>
// //               <ul>
// //                 <li>Initial release of AV Sync web app</li>
// //                 <li>CRUD + Inventory Management</li>
// //                 <li>Maintenance Scheduling</li>
// //                 <li>PDF Exporting</li>
// //                 <li>Firebase Authentication</li>
// //               </ul>
// //             </li>
// //           </ul>
// //         </div>

// //         {/* --- BETA NOTES CARD --- */}
// //         <div id="beta" className="post-item">
// //           <h2 className="post-title">📝 Beta Release Notes</h2>

// //           <ul className="post-pargrphs">
// //             <li>
// //               This version uses <strong>mock device data</strong> for testing
// //             </li>
// //             <li>Export filters + side menus still in development</li>
// //             <li>Email verification + role management coming soon</li>
// //             <li>
// //               Some responsive layout shifts — refining for smaller screens
// //             </li>
// //           </ul>
// //         </div>

// //         {/* --- FEEDBACK CARD --- */}
// //         <div className="post-item">
// //           <h2 className="post-title">💬 Share Your Feedback</h2>
// //           <p className="post-pargrphs">
// //             If you find bugs, notice issues, or have ideas — I’d love to hear
// //             from you!
// //             <br />
// //             <a
// //               className="post-links"
// //               href="mailto:scvictoria@wanderstudios.org"
// //             >
// //               scvictoria@wanderstudios.org
// //             </a>
// //           </p>
// //         </div>
// //       </div>
// //     </>
// //   );
// // }
// import React from "react";
// import avsyncImg from "../imgs/avsync.jpg";
// import "../App.css";
// import { Helmet } from "react-helmet";

// export default function AvSyncPage() {
//   return (
//     <>
//       {/* SEO META TAGS */}
//       <Helmet>
//         <title>AV Sync — Beta Launch + Scanner Utility</title>
//         <meta
//           name="description"
//           content="AV Sync is a cross-platform device management tool built by Savannah Chanel Victoria — featuring network scanning, maintenance scheduling, reporting, and more."
//         />
//         <meta
//           name="keywords"
//           content="AV Sync, network scanner, AV engineering, live production tools, device inventory, technical director tools, Firebase Auth, React Native, capstone project"
//         />
//         <meta property="og:title" content="AV Sync — Beta Launch" />
//         <meta
//           property="og:description"
//           content="Cross-platform AV device manager with scanning, inventory, alerts, and PDF reporting — built by Savannah Chanel Victoria."
//         />
//         <meta
//           property="og:image"
//           content="https://savannahchanel.me/assets/avsync-thumbnail.jpg"
//         />
//         <meta property="og:url" content="https://savannahchanel.me/avsync" />
//       </Helmet>

//       <div className="posts">
//         {/* 🔥 NEW RELEASE BANNER */}
//         <div className="post-item" style={{ background: "#222" }}>
//           <h2 className="post-title">🚀 New Release: Local Scanner Utility</h2>
//           <p className="post-pargrphs">
//             As of <strong>November 22, 2025</strong>, AV Sync now includes a
//             standalone <strong>Local Scanner Utility</strong> that lets you
//             perform REAL network scans on your own machine and sync the results
//             directly to your AV Sync account. This is the recommended way to use
//             AV Sync if you want live device discovery.
//           </p>

//           {/* <a
//             href="/assets/AVSync-LocalScanner-Release.zip"
//             download
//             className="download-btn"
//           >
//             Download Local Scanner Utility
//           </a> */}
//           <a href="/avsync/ScannerDocs.js" download className="download-btn">
//             Scanner Documentation
//           </a>
//         </div>

//         {/* HEADER ------------------------------------------------------ */}
//         <h1>AV Sync</h1>
//         <p className="intro-text">
//           A cross-platform device management tool built for production and
//           technical teams — designed to help track AV equipment, schedule
//           maintenance, and keep your network organized.
//         </p>

//         {/* MAIN FEATURE CARD ----------------------------------------- */}
//         <div className="post-item">
//           <img src={avsyncImg} alt="AV Sync screenshot" className="post-img" />

//           <div className="post-content">
//             <h2 className="post-title">Core Features</h2>

//             <ul className="post-pargrphs">
//               <li>Device inventory + editable device profiles</li>
//               <li>Secure Firebase Authentication</li>
//               <li>CRUD operations with Axios + MongoDB backend</li>
//               <li>Maintenance scheduling with custom alerts</li>
//               <li>PDF exports (IT Tickets + Device Reports)</li>
//               <li>
//                 Real-time device scanning{" "}
//                 <strong>(via Local Scanner Utility)</strong>
//               </li>
//             </ul>

//             <div className="project-links">
//               <a
//                 className="post-links"
//                 href="https://2506-wdv-349-victoria-savannah.vercel.app"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Live Beta (Mock Data)
//               </a>

//               <a className="post-links" href="#scanner-mode">
//                 Scanner Mode Info
//               </a>

//               <a className="post-links" href="#changelog">
//                 Changelog
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* SCANNER MODE ------------------------------------------------ */}
//         <div id="scanner-mode" className="post-item">
//           <h2 className="post-title">🔍 Scanner Mode (Recommended)</h2>

//           <p className="post-pargrphs">
//             Because browsers <strong>cannot</strong> scan local networks for
//             security reasons, AV Sync runs in two modes:
//           </p>

//           <ol className="post-pargrphs">
//             <li>
//               <strong>Mock Data Web Version</strong> — safe, easy to test, great
//               for demos.
//             </li>
//             <li>
//               <strong>Scanner Mode</strong> — uses the standalone Local Scanner
//               Utility to perform real IP/MAC discovery on your personal network.
//             </li>
//           </ol>

//           <p className="post-pargrphs">
//             The scanner runs locally on your computer, discovers devices, and
//             syncs everything to your AV Sync account using your unique Firebase
//             UID.
//           </p>

//           <a
//             href="/assets/AVSync-LocalScanner-Release.zip"
//             download
//             className="download-btn"
//           >
//             Download Scanner Utility
//           </a>
//         </div>

//         {/* TRANSPARENCY NOTES ----------------------------------------- */}
//         <div className="post-item">
//           <h2 className="post-title">⚠️ Transparency Notes</h2>

//           <p className="post-pargrphs">
//             The <strong>web version</strong> of AV Sync currently uses mock data
//             for device listings due to browser limitations — websites cannot
//             detect IP devices on a user’s network.
//           </p>

//           <p className="post-pargrphs">
//             The newly released <strong>Local Scanner Utility</strong> solves
//             this by running locally on your machine, discovering devices, and
//             sending them securely to your AV Sync database.
//           </p>

//           <p className="post-pargrphs">
//             A future update will connect Scanner Mode more tightly into the
//             browser app, but for now this hybrid workflow is the most seamless
//             approach for real-world AV teams.
//           </p>
//         </div>

//         {/* ACCESS ------------------------------------------------------ */}
//         <div className="post-item">
//           <h2 className="post-title">🔐 Access Information</h2>

//           <p className="post-pargrphs">
//             You can create your own account or use the demo login:
//           </p>

//           <ul className="post-pargrphs">
//             <li>
//               Email: <code>test@email.com</code>
//             </li>
//             <li>
//               Password: <code>Test1234!</code>
//             </li>
//           </ul>
//         </div>

//         {/* TEST CHECKLIST --------------------------------------------- */}
//         <div className="post-item">
//           <h2 className="post-title">✅ What to Test</h2>

//           <ul className="post-pargrphs">
//             <li>Login / Registration (Firebase Auth)</li>
//             <li>Add, edit, delete devices</li>
//             <li>Maintenance scheduling + custom reminder alerts</li>
//             <li>PDF exports (IT Ticket + Device Report)</li>
//             <li>Scanner Mode → run Local Scanner Utility + refresh web app</li>
//             <li>User experience feedback</li>
//           </ul>
//         </div>

//         {/* CHANGELOG --------------------------------------------------- */}
//         <div id="changelog" className="post-item">
//           <h2 className="post-title">📝 Changelog</h2>

//           <ul className="post-pargrphs">
//             <li>
//               <strong>v1.1 — Nov 22, 2025:</strong> Released Local Scanner
//               Utility (macOS). Added UID syncing + improved fallback names.
//             </li>
//             <li>
//               <strong>v1.0 — Nov 16, 2025:</strong> Beta launch (Mock Data),
//               CRUD, scheduling, PDF exports, IT Ticket generator.
//             </li>
//           </ul>
//         </div>

//         {/* FEEDBACK --------------------------------------------------- */}
//         <div className="post-item">
//           <h2 className="post-title">💬 Share Your Feedback</h2>
//           <p className="post-pargrphs">
//             If you find bugs or have ideas, I’d love to hear from you.
//             <br />
//             <a
//               className="post-links"
//               href="mailto:scvictoria@wanderstudios.org"
//             >
//               scvictoria@wanderstudios.org
//             </a>
//           </p>
//         </div>
//       </div>
//     </>
//   );
// }
/**NEW UDAPTE as of 11.23 */

import React from "react";
import avsyncImg from "../imgs/avsync.jpg";
import "../App.css";
import { Helmet } from "react-helmet";

export default function AvSyncPage() {
  return (
    <>
      {/* SEO META TAGS */}
      <Helmet>
        <title>AV Sync — Device Management App</title>
        <meta
          name="description"
          content="AV Sync is a cross-platform device management tool built by Savannah Chanel Victoria — designed for AV teams to scan, track, and manage production network devices."
        />
      </Helmet>

      <div className="posts">
        {/* 🔥 NEW RELEASE BANNER */}
        <div className="post-item" style={{ background: "#222" }}>
          <h2 className="post-title">🚀 New Release: Local Scanner Utility</h2>
          <p className="post-pargrphs">
            As of <strong>November 22, 2025</strong>, AV Sync now includes a
            standalone <strong>Local Scanner Utility</strong> for performing
            REAL network scans directly from your computer — with device results
            automatically syncing into your AV Sync account.
          </p>

          <div style={{ marginTop: "1rem" }}>
            <a
              href="/assets/AVSync-LocalScanner-Release.zip"
              download
              className="download-btn"
            >
              Download Scanner Utility
            </a>

            <a
              style={{ marginLeft: "1rem" }}
              className="post-links"
              href="/avsync/scanner"
            >
              Scanner Documentation →
            </a>
            <div className="project-tags">
              <a
                className="post-links"
                href="https://github.com/VictoriaSavannah-FS/avsync-scanner-public"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on GitHub
              </a>

              <span className="license-badge">MIT License</span>
            </div>
          </div>
        </div>

        {/* HEADER */}
        <h1>AV Sync</h1>
        <p className="intro-text">
          AV Sync is a cross-platform device management tool for production
          teams — designed to help keep your network devices organized, updated,
          and fully documented.
        </p>

        {/* ---------------------------------------------------------------- */}
        {/* MAIN FEATURE CARD */}
        <div className="post-item">
          <img src={avsyncImg} alt="AV Sync screenshot" className="post-img" />

          <div className="post-content">
            <h2 className="post-title">Core Features</h2>

            <ul className="post-pargrphs">
              <li>Inventory management with editable device profiles</li>
              <li>Secure Firebase user authentication</li>
              <li>Full CRUD support through API</li>
              <li>Maintenance scheduling + reminder alerts</li>
              <li>Exportable PDF reports (IT Tickets + Device Summaries)</li>
              <li>
                Real-time device scanning{" "}
                <strong>(via Local Scanner Utility)</strong>
              </li>
            </ul>

            <div className="project-links">
              <a
                className="post-links"
                href="https://avsync.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                Launch Web App →
              </a>

              <a className="post-links" href="/avsync/docs">
                Documentation Hub →
              </a>
            </div>
          </div>
        </div>

        {/* ---------------------------------------------------------------- */}
        {/* WHY AV SYNC EXISTS */}
        <div className="post-item">
          <h2 className="post-title">Why AV Sync?</h2>
          <p className="post-pargrphs">
            As a Technical Director and Audio Engineer, I built AV Sync to solve
            a real need: keeping track of dozens of network devices, firmware
            versions, IP addresses, and maintenance schedules — all in one
            place. AV Sync brings clarity, automation, and organization to AV
            production environments.
          </p>
        </div>

        {/* ---------------------------------------------------------------- */}
        {/* TECH STACK */}
        <div className="post-item">
          <h2 className="post-title">Tech Stack</h2>
          <ul className="post-pargrphs">
            <li>React + Expo (Frontend)</li>
            <li>Node.js + Express + MongoDB (Backend)</li>
            <li>Firebase Authentication (User Management)</li>
            <li>Axios API Integration</li>
            <li>Standalone Node-based Scanner Utility</li>
          </ul>

          <p className="post-pargrphs">
            For full architecture details, see the{" "}
            <a className="post-links" href="/avsync/docs">
              Documentation Hub →
            </a>
          </p>
        </div>

        {/* ---------------------------------------------------------------- */}
        {/* FEEDBACK */}
        <div className="post-item">
          <h2 className="post-title">💬 Feedback</h2>
          <p className="post-pargrphs">
            Have ideas or see a bug? I’d love to hear from you!
            <br />
            <a
              className="post-links"
              href="mailto:scvictoria@wanderstudios.org"
            >
              scvictoria@wanderstudios.org
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
